import React, { useEffect, useState } from 'react'
import grievanceRemarkServices from '../grievanceRemarkServices';
import { useAppData } from '../../../../../../context/AppDataContext';
import moment from 'moment';

function GrievanceRemarkList({grievanceId,refreshTrigger}) {

    const [grievanceRemarkList,setGrievanceRemarkList] = useState(null);
    const {userDD,getDDDataById} = useAppData();

    const getGrievanceRemarkList = () =>{
        grievanceRemarkServices.getList(grievanceId).then(res=>{
            setGrievanceRemarkList(res.data);
        }).catch(error=>{

        })
    }

    useEffect(()=>{
        getGrievanceRemarkList();
    },[grievanceId,refreshTrigger])

    return (
        <div className='row'>
            <div className='col-md-12'>
                { grievanceRemarkList && grievanceRemarkList.map(remark=>
                 <div className='' key={remark.id} >   
                    <div><span className='fw-bold'>{getDDDataById(userDD,remark.userId).firstName}</span> Add remark on <span className='fw-bold'> {moment(remark.created_at).format("LLLL")}</span> </div>
                    <div className='p-2 mb-3 border rounded'>{remark.remark}</div>
                 </div>
                )}
            </div>
        </div>
    )
}

export default GrievanceRemarkList